import { Avatar as MuiAvatar } from '@mui/material';
import { ComponentProps } from 'react';

type Props = { bgColor?: string } & ComponentProps<typeof MuiAvatar>;

export function Avatar({ bgColor, sx, ...props }: Props) {
  return (
    <MuiAvatar
      {...props}
      sx={{
        width: '22px',
        height: '22px',
        color: '#FFF',
        textAlign: 'center',
        fontSize: '12px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '18px',
        backgroundColor: bgColor || '#0BA5EC',
        ...sx,
      }}
    />
  );
}
